module.exports = __webpack_public_path__ + "static/media/jmc-head.64aba230.jpg";